import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/1.jpg';
// import p2 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/2.jpg';
// import p3 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/3.jpg';
// import p4 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/4.jpg';
// import p5 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/5.jpg';
// import p6 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/6.jpg';


import Ecoclub2023 from 'views/EnvironmentDay2023/Ecoclub2023';

import SideHealth from 'views/HealthAndWellnesClub/SideHealth';

import { Typography } from '@mui/material';
import Container from 'components/Container';

import EcoAssociationSidebar2026 from '../EcoAssociationSidebar2026/EcoAssociationSidebar2026';
import EcoAssociationSidebar from '../EcoAssociationSidebar';


const EcoAssociation10Class2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/association/ecoassociation/ecoassociation10/6.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
     {
      src: p5,
      source: p5,
      rows: 1,
      cols: 1,
    },
     {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
            Twist the Poster    
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 10  Date: 05.06.26
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       The Eco Association organized a poster-making activity <strong>&apos;Twist the Poster&apos;</strong> for Class 10, on the theme <strong>&apos;Urgent Climate Change - Climate Change and Environmental Solutions&apos;</strong>. The activity aimed to sensitize students to the pressing environmental concerns and inspire them to explore innovative solutions through creative expression.
        <br></br>
Students participated enthusiastically, presenting visually appealing and thought-provoking posters on various aspects of climate change, environmental conservation, sustainable living and ecological responsibility. Their artwork reflected a deep understanding of contemporary environmental challenges and highlighted the importance of collective action in protecting our planet.
        <br></br>
This activity provided a platform for students to showcase their creativity, critical thinking and environmental awareness. It encouraged meaningful discussions on climate-related issues and reinforced the role of young people as responsible global citizens of the environment. The event was a great success, fostering environmental consciousness and motivating students to contribute towards a greener and more sustainable future.
        <br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Creative minds don't just recycle waste; they reinvent the future."
<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoAssociationSidebar2026/>
             </Box>
             <Box marginBottom={4}>
               <EcoAssociationSidebar/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoAssociation10Class2026;
